export var mutations = {
    authChecked: function (state, payload) {
        state.authChecked = payload;
    },
    setRoute: function (state, route) {
        state.route = route;
    },
    setModule: function (state, module) {
        state.activeModule = module;
    },
    setFeatures: function (state, features) {
        state.features = features;
    },
    setDraftingTableState: function (state, draftingTableState) {
        state.draftingTableState = draftingTableState;
    },
    setHideMainNav: function (state, hide) {
        state.hideMainNav = hide;
    },
    setUsingMobile: function (state, using) {
        state.hideMainNav = using;
    },
    setAttributes: function (state, attributes) {
        state.attributes = attributes;
    },
    setLoadingAttributes: function (state, loading) {
        state.loadingAttributes = loading;
    },
};
export var types = {
    SET_MODULE: 'setModule',
    SET_ROUTE: 'setRoute',
    SET_FEATURES: 'setFeatures',
    SET_DRAFTING_TABLE_STATE: 'setDraftingTableState',
    SET_HIDE_MAIN_NAV: 'setHideMainNav',
    SET_USING_MOBILE: 'setUsingMobile',
    SET_ATTRIBUTES: 'setAttributes',
    SET_LOADING_ATTRIBUTES: 'setLoadingAttributes',
};
